import { elakay_API } from "../../config";
import {decryptData}  from '../auth/elakayCryptage'
import {isAuthenticated  } from "../auth";
import { prepareUpload } from "../../utils/uploadPolicy";
import { readJsonOrUploadError, uploadErrorResult } from "../../utils/uploadResponse";

const normalizeToken = (value) => {
  if (typeof value !== "string") return "";
  const token = value.trim();
  if (!token || token === "undefined" || token === "null" || token === "false") return "";
  return token.split(".").length === 3 ? token : "";
};
const getAuthToken = () => normalizeToken(isAuthenticated()?.token);
const bearerHeaders = (headers = {}) =>
  Object.fromEntries(
    Object.entries(headers)
      .map(([key, value]) => [key, normalizeToken(value)])
      .filter(([, value]) => value)
      .map(([key, value]) => [key, `Bearer ${value}`])
  );

// --------------------------Create firts Category-------------------------------
export const FirstCategory = (token, category) => {
    return fetch(`${elakay_API}/categories/create`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(category)
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};

// --------------------------Create Category-------------------------------
export const createCategory = async (token, category, elakayCategoryID) => {
       try {
 const response = await fetch(`${elakay_API}/categories/createSupCategory/${elakayCategoryID}`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(category)
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

       const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
        const donneesClaires = await decryptData(encryptedData);
    
        return donneesClaires;
} catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
   return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  } 
};

// --------------------------Reading Categories By ID-------------------------------
// includeHidden: admin-only escape hatch (used by addCategory.jsx, the
// /category admin page) to also receive effectively-hidden categories so
// they stay administrable/reactivatable. Every other caller (Add/Edit
// Product pickers, public nav/shop pages) omits it and gets the
// public-filtered response automatically.
export const getCategoriesByID = async (elakayCategoryID, { includeHidden = false } = {}) => {

    try {
     const response = await fetch(`${elakay_API}/categories/readCategoryByID/${elakayCategoryID}${includeHidden ? "?includeHidden=true" : ""}`, {
        method: "GET"
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

    const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);
    return donneesClaires;
    
} catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
   return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  } 
};


export const getCategoriesByName = async (skip, limit, params) => { 
    try{
   const response = await fetch(`${elakay_API}/categories/cartegoryShearch?search=${params}&skip=${skip}&order=desc&limit=${limit}`, {
        method: "GET"
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }
    const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
   return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }

};


export const loadAllCategorie = async (a, n) => {
  try {
    const response = await fetch(`${elakay_API}/Allcategories?Level=${a}&name=${n}`, {
      method: "GET"
    });

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

    const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;
  } catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
   return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
};


// --------------------------Delete Category And Sub Category-------------------------------
export const deleteItemAndCategory = (categoryID, subCategoryID, token) => {
    return fetch(`${elakay_API}/categories/deleteItems/${categoryID}/${subCategoryID}`, {
        method: "DELETE",
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`
        }
    })
        .then(response => {
            return response.json();
        })
        .catch(err => { console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    }});
};

// --------------------------Create Filter Name for Product-------------------------------
export const createFilterName = (categoryID, token, name) => {
    return fetch(`${elakay_API}/categories/updateFilterName/${categoryID}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(name)

    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};

// --------------------------Creat a filters--------------------------------
export const AddFilterName = (token, name) => {

    return fetch(`${elakay_API}/filters/create`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(name)
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};


// --------------------------Creat a filters--------------------------------
export const createSubFilter = (token, filterID, name) => {

    return fetch(`${elakay_API}/filters/createSubFilter/${filterID}`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(name)
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};


export const updateSubFilter = (token, filterID,  subFilter) => {
    return fetch(`${elakay_API}/filters/updateSubFilter/${filterID}`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(subFilter)

    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};


export const getFilterName = async (token) => {

     try{
   const response = await fetch(`${elakay_API}/filters/readFilters`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`
        }
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

    const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
   return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }

};

export const getFilterByID = async (filterID, token) => {

     try{
   const response = await fetch(`${elakay_API}/filters/readFiltersByID/${filterID}`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`
        }
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

     const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
   return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }

};

export const getSubFilterBykeyFilter = async (filterID, keyFilter) => {

     try{
   const response = await fetch(`${elakay_API}/filters/getSubFilterBykeyFilter/${filterID}?keyFilter=${keyFilter}`, {
        method: "GET",
        headers: {
            Accept: "application/json",
        }
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

     const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
   return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }

};

export const ReadFilterSelected = async (catID, token) => {
        try{
   const response = await fetch(`${elakay_API}/filters/ReadFilterSelected/${catID}`, {
        method: "GET",
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`
        }
    })

      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }

    const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

    } catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
   return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }

};

export const deteleFilter = (filterID, token) => {
    return fetch(`${elakay_API}/filters/deleteFilter/${filterID}`, {
        method: "DELETE",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })
        .then(response => {
            return response.json();
        })
        .catch(error => {});

}

export const updateTranslFil = (token,  filter, filterID) => {
    return fetch(`${elakay_API}/filters/updateTranslFil/${filterID}`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(filter)

    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};

export const updateFilter = (token, filterID,  filter) => {
    return fetch(`${elakay_API}/filters/updateFilter/${filterID}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(filter)

    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};

export const updateFiltersValue = (token, filterID,  name) => {
    return fetch(`${elakay_API}/filters/updateFilterItem/${filterID}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(name)

    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};

export const removeFilterValue = (filterID, name, token) => {
    return fetch(`${elakay_API}/filters/DeleteFilterValue/${filterID}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(name)

    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};

export const linkFTC = (catID, filID, token) => {
    return fetch(`${elakay_API}/filters/linkFTC/${catID}/${filID}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};

export const UnlinkFTC = (catID, filID, token) => {
    return fetch(`${elakay_API}/filters/UnlinkFTC/${catID}/${filID}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};

export const linkVFTC = (catID, filID, name, token) => {
    return fetch(`${elakay_API}/filters/linkVFTC/${catID}/${filID}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(name)
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};

export const UnlinkVFTC = (catID, filID, name, token) => {
    return fetch(`${elakay_API}/filters/UnlinkVFTC/${catID}/${filID}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(name)
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};

// --------------------------Delete Filter Name And Filter Value-------------------------------
export const deteleFilterName = (categoryID, filterID, token) => {
    return fetch(`${elakay_API}/categories/deleteFilter/${categoryID}/${filterID}`, {
        method: "DELETE",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        }
    })
        .then(response => {
            return response.json();
        })
        .catch(error => {});

}

// --------------------------Delete Filter Value-------------------------------
export const deleteFilterValue = (categoryID, token, Filters) => {
    return fetch(`${elakay_API}/categories/deleteFilterValue/${categoryID}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ Filters })

    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};


export const readFilterValue = async (elakayCategoryID, elakayfilterID) => {
    try {
    const response = await fetch(`${elakay_API}/categories/readFilterValue/${elakayCategoryID}/${elakayfilterID}`, {
        method: "GET"
    })


      // Vérifie si le statut est une erreur HTTP
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Erreur d'identification");
    }


  const encryptedData = await response.json(); // doit être au format chiffré (avec iv, salt, etc.)
    const donneesClaires = await decryptData(encryptedData);

    return donneesClaires;

} catch (err) {
    console.error("Erreur lors du chargement des catégories :", err);
   return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
  }
        
};
// --------------------------Update Filter Value -------------------------------
export const updateFilterValue = (categoryID, token, name, Filters) => {
    return fetch(`${elakay_API}/categories/updateFilterValue/${categoryID}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ name, Filters })

    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
}; 

// --------------------------Add a Pub 1500 X 400-------------------------------
// ===== FONCTION AddPub1500X400 (Pour Pub1200X500) =====
// Upload multiple photos avec naturalW, naturalH, deviseSize

export const AddPub1500X400 = async (token, day, categoryID, photos, imagePubID) => {
    let prepared;
    try { prepared = await Promise.all(photos.map((p) => prepareUpload('categoryImage', p.file))); }
    catch (error) { return uploadErrorResult(error); }
    const body = new FormData();
    
    // Ajouter les paramètres de base
    body.append('timer', day);
    body.append('categoryID', categoryID);
    if (imagePubID) {
        body.append('pubId', imagePubID);
    }
    
    // Ajouter chaque photo avec ses métadonnées
    photos.forEach((p, index) => {
        body.append('photos', prepared[index]);           // Fichier (vérifié / compressé si lourd)
        body.append(`w_${index}`, p.naturalW);            // Largeur réelle (1200 ou 800)
        body.append(`h_${index}`, p.naturalH);            // Hauteur réelle (500 ou 400)
        body.append(`deviseSize_${index}`, p.deviseSize); // 'd' ou 'm'
    });

    return fetch(`${elakay_API}/categories/Pub1500X400/${categoryID}?timer=${day}${imagePubID ? `&pubId=${imagePubID}` : ''}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`
        },
        body: body
    })
        .then(readJsonOrUploadError)
        .catch(err => {
            console.error("Erreur lors du chargement:", err);
            return {
                success: false,
                errors: [
                    { code: "NETWORK_ERROR", message: err.message }
                ]
            };
        });
};


// --------------------------Add a Pub C 400 X 400--------------------------------
export const AddPubC400X400 = async (token, day, categoryID, photo) => {

    let prepared;
    try { prepared = await prepareUpload('categoryImage', photo); }
    catch (error) { return uploadErrorResult(error); }
    const body = new FormData()
    body.append('photo', prepared)

    return fetch(`${elakay_API}/categories/PubC400X400/${categoryID}?timer=${day}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            // "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: body
    })
        .then(readJsonOrUploadError)
        .catch(err => {
             console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};

// --------------------------Add a Pub R 400 X 400--------------------------------
// ===== FONCTION AddPubR400X400 (Pour Pub700X700) =====
// Upload multiple photos avec naturalW, naturalH, deviseSize

export const AddPubR400X400 = async (token, day, categoryID, photos) => {
    let prepared;
    try { prepared = await Promise.all(photos.map((p) => prepareUpload('categoryImage', p.file))); }
    catch (error) { return uploadErrorResult(error); }
    const body = new FormData();
    
    // Ajouter les paramètres de base
    body.append('timer', day);
    body.append('categoryID', categoryID);
    
    // Ajouter chaque photo avec ses métadonnées
    photos.forEach((p, index) => {
        body.append('photos', prepared[index]);           // Fichier (vérifié / compressé si lourd)
        body.append(`w_${index}`, p.naturalW);            // Largeur réelle (700 ou 400)
        body.append(`h_${index}`, p.naturalH);            // Hauteur réelle (700 ou 712)
        body.append(`deviseSize_${index}`, p.deviseSize); // 'd' ou 'm'
    });

    return fetch(`${elakay_API}/categories/PubR400X400/${categoryID}?timer=${day}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`
        },
        body: body
    })
        .then(readJsonOrUploadError)
        .catch(err => {
            console.error("Erreur lors du chargement:", err);
            return {
                success: false,
                errors: [
                    { code: "NETWORK_ERROR", message: err.message }
                ]
            };
        });
};

// --------------------------Add a Pub R 400 X 400--------------------------------
export const DeletePub = (token, categoryID, pubID, pub) => {

    return fetch(`${elakay_API}/categories/deletepub/${categoryID}/${pubID}/${pub}`, {
        method: "DELETE",
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`
        }
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};

export const UpadateNameCat = (token, name, CategoryID) => {
    return fetch(`${elakay_API}/categories/UpadateNameCat/${CategoryID}`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(name)
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};

export const updateTranslationsCat = (token, catTranslate, CategoryID) => {
    return fetch(`${elakay_API}/categories/updateTranslations/${CategoryID}`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(catTranslate)
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};

export const UnlinkCTC = (categoryID, subCategoryID, token) => {
    return fetch(`${elakay_API}/categories/UnlinkCTC/${categoryID}/${subCategoryID}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`
        }
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    }
        });
};

export const LinkCTC = (categoryID, subCategoryID, token) => {
    return fetch(`${elakay_API}/categories/linkCTC/${categoryID}/${subCategoryID}`, {
        method: "PUT",
        headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`
        }
    })
        .then(response => {
            return response.json();
        })
        .catch(err =>{ console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    }});
};

// --------------------------Reorder a Category among its siblings-------------------------------
// Moves categoryId to newPosition (0-based) among the categories sharing the
// same parent. The server is the source of truth: it re-derives the parent
// and the current position from MongoDB itself, it never trusts an
// oldPosition computed on the front.
export const updateCategoryPosition = (token, categoryId, newPosition) => {
    return fetch(`${elakay_API}/categories/${categoryId}/position`, {
        method: "PATCH",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ newPosition })
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};

// -------------------------- Toggle a category's own visibility -------------------------------
// Own flag only -- the server never cascades this onto children (see
// updateCategoryVisibility in elakay_controllers/category/category.js).
export const updateCategoryVisibility = (token, categoryId, isVisible) => {
    return fetch(`${elakay_API}/categories/${categoryId}/visibility`, {
        method: "PATCH",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ isVisible })
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};

// Matrix Mode of ONE category (addCategory.jsx): controls how its direct
// children are illustrated, never its own image. Family-only on the server.
export const updateCategoryMatrixMode = (token, categoryId, matrixMode) => {
    return fetch(`${elakay_API}/categories/${categoryId}/matrix-mode`, {
        method: "PATCH",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ matrixMode })
    })
        .then(response => {
            return response.json();
        })
        .catch(err => {
             console.error("Erreur lors du chargement :", err);
    return {
      success: false,
      error: err.message || "Une erreur inconnue est survenue"
    };
        });
};

// Public: { parents: { [parentId]: { matrixMode: true, children: { [childId]: [{ _id, publicId, name, imageUrl }] } } } }
// for every matrix-enabled parent in `categoryId`'s branch. A parent absent
// from `parents` has Matrix Mode OFF (its children keep their own image).
export const getCategoryMatrixPreviews = async (categoryId, { levels } = {}) => {
    try {
        const query = levels ? `?levels=${encodeURIComponent(levels)}` : "";
        const response = await fetch(`${elakay_API}/categories/${categoryId}/matrix-previews${query}`, { method: "GET" });
        const data = await response.json();
        if (!response.ok || !data || data.success === false) {
            return { success: false, error: data?.error || data?.message || "Unable to load Matrix Mode previews", parents: {} };
        }
        return data;
    } catch (err) {
        console.error("Erreur lors du chargement des aperçus Matrix Mode :", err);
        return { success: false, error: err.message || "Une erreur inconnue est survenue", parents: {} };
    }
};

// À ajouter dans votre fichier API
export const updateCategorySettings = async (categoryId, pageCategory) => {
    try {
        const response = await fetch(`${elakay_API}/category/${categoryId}/page-settings`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                ...bearerHeaders({ Authorization: getAuthToken() })
            },
            body: JSON.stringify({ pageCategory })
        });
        
        return await response.json();
    } catch (error) {
        console.error('Error updating category settings:', error);
        throw error;
    }
};
